import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ImageWithBasePath } from 'Core/components';
import ToastService from '../../../service/toast-service';
import { ShipmentService } from '../../../service/api/shipment-service';
const ImportShipment = ({ onUploadSuccess, onClose }) => {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  // Handle modal close
  const handleClose = () => {
    setFile(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    if (onClose) {
      onClose();
    }
  };
  // Setup Bootstrap modal close handler
  useEffect(() => {
    const modal = document.getElementById('view-notes');
    if (modal) {
      modal.addEventListener('hidden.bs.modal', handleClose);
      return () => {
        modal.removeEventListener('hidden.bs.modal', handleClose);
      };
    }
  }, [onClose]);

  const handleFile = selectedFile => {
    if (selectedFile) {
      // Validate file extension
      const fileName = selectedFile.name.toLowerCase();
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        showToastMessage(
          ToastService.error('Please select a valid Excel file (.xlsx or .xls)', {
            position: ToastService.positions.TOP_RIGHT,
            onClose: handleCloseToast,
          }),
        );
        return;
      }

      // Validate file size (e.g., 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (selectedFile.size > maxSize) {
        showToastMessage(
          ToastService.error('File size should be less than 10MB', {
            position: ToastService.positions.TOP_RIGHT,
            onClose: handleCloseToast,
          }),
        );
        return;
      }

      setFile(selectedFile);
    }
  };

  // Handle click on the upload area
  const handleClick = () => {
    inputRef.current.click();
  };

  // Handle file selection through input
  const handleChange = e => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  // Handle drag events
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // Handle drop event
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleUpload = async e => {
    e.preventDefault();

    if (!file) {
      showToastMessage(
        ToastService.error('Please select a file first', {
          position: ToastService.positions.TOP_RIGHT,
          onClose: handleCloseToast,
        }),
      );
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fileType', 'Shipment');
      const response = await ShipmentService.importShipment(formData);
       
      if (response.status == '200') {
        alert("Upload success");
        setFile(null);
        if (inputRef.current) {
          inputRef.current.value = '';
        }
        handleClose();
        // Notify parent component
        if (onUploadSuccess) {
          onUploadSuccess();
        }
      } else {
        alert(response.errorMessage?.message || 'Failed to upload shipments');
        showToastMessage(          
          ToastService.error(response.errorMessage?.message || 'Failed to upload shipments', {
            position: ToastService.positions.TOP_RIGHT,
            onClose: handleCloseToast,
          }),
        );
        console.error('Error upload shipments:', response.errorMessage?.message);
      }
    } catch (error) {
      alert(error.message || 'Error uploading file');
    } finally {
      setUploading(false);
    }
  };

  const handleCloseToast = () => {
    setShowToast(false);
    setCurrentToast(null);
  };

  const showToastMessage = toastElement => {
    setCurrentToast(toastElement);
    setShowToast(true);
    setTimeout(handleCloseToast, 6000);
  };

  return (
    <div className="modal fade" id="view-notes">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Upload Shipment</h4>
                </div>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form onSubmit={handleUpload}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="input-blocks image-upload-down">
                        <label>Upload Excel File</label>
                        <div
                          className={`image-upload download ${dragActive ? 'drag-active' : ''}`}
                          onClick={handleClick}
                          onDragEnter={handleDrag}
                          onDragLeave={handleDrag}
                          onDragOver={handleDrag}
                          onDrop={handleDrop}
                        >
                          {/* Hidden file input */}
                          <input
                            ref={inputRef}
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleChange}
                            className="d-none"
                          />

                          <div className="image-uploads">
                            <ImageWithBasePath src="assets/img/download-img.png" alt="img" />
                            {file ? (
                              <div className="selected-file">
                                <h4>Selected File: {file.name}</h4>
                                <p>Size: {(file.size / 1024 / 1024).toFixed(2)} MB</p>
                              </div>
                            ) : (
                              <h4>
                                Drag and drop a <span>file to upload</span>
                                <br />
                                <span className="small">or click to select</span>
                              </h4>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div className="modal-footer-btn">
                    <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-submit" disabled={!file || uploading}>
                      {uploading ? 'Uploading...' : 'Submit'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showToast && currentToast}
    </div>
  );
};

ImportShipment.propTypes = {
  onUploadSuccess: PropTypes.func,
  onClose: PropTypes.func,
};
export default ImportShipment;
